var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_vm._l((_vm.schema),function(field,index){return _c('v-row',{key:`row-${index}`,staticClass:"py-1",attrs:{"no-gutters":""}},[_c('v-col',[_vm._t(field.name)],2)],1)}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }